import styled from "styled-components";
import { Label as LabelPrimitive } from "../primitives/Label";
import { colors, typeface } from "../theme";

interface LabelProps {
  error?: boolean;
}
export const Label = styled(LabelPrimitive)<LabelProps>`
  color: ${props => (props.error ? colors.redD : colors.gray6)};
  font-family: ${typeface.primary};
  line-height: 1rem;
  padding: 0;
`;
